export const fadeIn = {
  enter: 'tw-transition tw-ease-in-out tw-duration-300',
  enterFrom: 'tw-opacity-0',
  enterTo: 'tw-opacity-100',
  leave: 'tw-transition tw-ease-in-out tw-duration-300',
  leaveFrom: 'tw-opacity-100',
  leaveTo: 'tw-opacity-0',
}

export const slideInFromTop = {
  enter: 'tw-transition tw-ease-in-out tw-duration-500',
  enterFrom: 'tw-custom-translate-y-full',
  enterTo: 'tw-custom-translate-y-0',
  leave: 'tw-transition tw-ease-in-out tw-duration-500',
  leaveFrom: 'tw-custom-translate-y-0',
  leaveTo: 'tw-custom-translate-y-full',
}
